var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 2.23077C2.31996 2.23077 2.25 2.29965 2.25 2.38462V5.11538C2.25 5.20035 2.31996 5.26923 2.40625 5.26923H17.5938C17.68 5.26923 17.75 5.20035 17.75 5.11538V2.38462C17.75 2.29965 17.68 2.23077 17.5938 2.23077H2.40625ZM1 2.38462C1 1.61991 1.6296 1 2.40625 1H17.5938C18.3704 1 19 1.61991 19 2.38462V5.11538C19 5.88009 18.3704 6.5 17.5938 6.5H2.40625C1.6296 6.5 1 5.88009 1 5.11538L1 2.38462Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 8.73077C2.31996 8.73077 2.25 8.79965 2.25 8.88462V11.6154C2.25 11.7004 2.31996 11.7692 2.40625 11.7692H17.5938C17.68 11.7692 17.75 11.7004 17.75 11.6154V8.88462C17.75 8.79965 17.68 8.73077 17.5938 8.73077H2.40625ZM1 8.88462C1 8.11991 1.6296 7.5 2.40625 7.5H17.5938C18.3704 7.5 19 8.11991 19 8.88462V11.6154C19 12.3801 18.3704 13 17.5938 13H2.40625C1.6296 13 1 12.3801 1 11.6154L1 8.88462Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40625 15.2308C2.31996 15.2308 2.25 15.2996 2.25 15.3846V18.1154C2.25 18.2004 2.31996 18.2692 2.40625 18.2692H17.5938C17.68 18.2692 17.75 18.2004 17.75 18.1154V15.3846C17.75 15.2996 17.68 15.2308 17.5938 15.2308H2.40625ZM1 15.3846C1 14.6199 1.6296 14 2.40625 14H17.5938C18.3704 14 19 14.6199 19 15.3846V18.1154C19 18.8801 18.3704 19.5 17.5938 19.5H2.40625C1.6296 19.5 1 18.8801 1 18.1154L1 15.3846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6f62b68e0dbc85771880e181e4690616.svg";
export { ForwardRef as ReactComponent };